import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FirstShiftWasAttendedHttpModel } from '../../http/first-shift/first-shift-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const FirstShiftAppointmentStatusActions = createActionGroup({
  source: 'First Shift Appointment Status',
  events: {
    'Load First Shift Appointment Status': emptyProps(),
  },
});

export const FirstShiftAppointmentStatusAPIActions = createActionGroup({
  source: 'First Shift Appointment Status API',
  events: {
    'Loaded First Shift Appointment Status Successfully': props<{
      attendedData: FirstShiftWasAttendedHttpModel | null;
    }>(),
    'Loaded First Shift Appointment Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
